
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/battle-demo/battle-pass",
      function () {
        return require("private-next-pages/battle-demo/battle-pass.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/battle-demo/battle-pass"])
      });
    }
  